import { createFileRoute, redirect } from '@tanstack/react-router';

// Links sent before the fix pointed here. The page lives under /passport.
export const Route = createFileRoute('/transfer/$transferId')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/passport/transfer/$transferId',
      params: { transferId: params.transferId },
      search: search as Record<string, string>,
      replace: true,
    });
  },
});
